import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { N08TabsProps } from './N08Tabs.types';
import { TabsList, TabsTrigger } from '@ahc-digital/component-library';
import { TAB_CONTAINER_VALUE } from 'src/shared/static';
import { getDroplink } from 'src/shared/param-utils';

export function GetN08TabModel(props?: N08TabsProps) {
  const { params, rendering } = props || {};

  const tabs = rendering?.placeholders?.[TAB_CONTAINER_VALUE]?.filter(
    ({ uid, componentName }) => !!uid && componentName === 'N08Tab'
  );

  const tabTriggers = tabs?.map((tab, idx) => {
    return (
      <TabsTrigger key={idx} value={tab?.uid || ''}>
        <Text field={tab?.fields?.TabTitle} />
      </TabsTrigger>
    );
  });

  const children = (
    <>
      <TabsList>{tabTriggers}</TabsList>
      {rendering && <Placeholder name={TAB_CONTAINER_VALUE} rendering={rendering} />}
    </>
  );

  const defaultValue =
    rendering?.placeholders?.[TAB_CONTAINER_VALUE]?.find(({ uid }) => !!uid)?.uid || '';

  return {
    size: getDroplink(params?.TitleSize, 'small'),
    children,
    defaultValue,
  };
}
